import React from "react";
import Header from './Components/Header'
import Footer from './Components/Footer'
import Main from './Pages/Main'
import Login_Signup from './Pages/Login_Signup'
import Not_Found from './Pages/Not_Found'
import Blog from './Pages/Blog'
import Blogs from './Pages/Blogs'
import Products_List from './Pages/Product_List'
import Product_Page from './Pages/Product'
import ManageSite_Page from './Pages/Manage_Site'
import UserSettings_Page from './Pages/UserSettings'
import './Style/Index.css'
import { BrowserRouter, Router, Routes, Route } from 'react-router-dom';
import ShieldIcon from './Shield Checktest.svg'


function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path='/' element={<Main />} />
        <Route path='/login' element={<Login_Signup />} />
        <Route path='/user' element={<UserSettings_Page />} />
        <Route path='/user/:Section' element={<UserSettings_Page />} />
        <Route path='/user/*' element={<Not_Found />} />
        <Route path='/admin/manage-server' element={<ManageSite_Page />} />
        <Route path='/product/:ProductSection' element={<Products_List />} />
        <Route path='/product/:ProductSection/:Production' element={<Product_Page />} />
        <Route path='/product/*' element={<Not_Found />} />
        <Route path='/blogs' element={<Blogs />} />
        <Route path='/blogs/blog/:BlogName' element={<Blog />} />
        <Route path='/blogs/blog/*' element={<Not_Found />} />
        <Route path='*' element={<Not_Found />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
